import React, { useState, useEffect, useContext } from "react"
import { Card, CardHeader, Row, Col, Button } from "reactstrap"
import { withRouter } from "react-router"
import { Query, Subscription } from "react-apollo"
import { flowRight as compose } from "lodash"
import { useSubscription, useMutation } from "@apollo/react-hooks"
import PropTypes from "prop-types"
import withModal from "components/modal"
import { chatRoom } from "gql/queries"
import { leaveChatRoom as mutation } from "gql/mutations"
import {
  chatRoomMessage,
  chatRoomMessageIsReadUpdated
} from "gql/subscriptions"
import { userInfo } from "utils"
import MessageListBody from "./MessageListBody"
import MessageContext from "../MessageContext"

const MessageQueryWrapper = props => {
  const [messages, setMessages] = useState([])
  const [submitDisabled, setSubmitDisabled] = useState(null)
  const [onServiceAssistant, setOnServiceAssistant] = useState("")
  const { setChatUser, setIsInitChat, setChatRoomId, isInitChat } = useContext(
    MessageContext
  )
  const { chatUser, isCustomer } = props
  const chatRoomId = !isCustomer ? props.chatRoomId : userInfo().chatRoomId
  const [leaveChatRoom] = useMutation(mutation, {
    variables: { id: chatRoomId }
  })

  useInit(messages, setIsInitChat)
  const { data } = useSubscription(chatRoomMessageIsReadUpdated, {
    variables: { chatRoomId }
  })

  if (data) {
    const readMessageIds = data.chatRoomMessageIsReadUpdated.chatMessages.map(
      m => m.id
    )

    let messagesToBeUpdatedCount = readMessageIds.length

    for (let index = messages.length - 1; index >= 0; index--) {
      if (readMessageIds.includes(messages[index].id)) {
        messages[index].isRead = true
        messagesToBeUpdatedCount -= 1
      }

      if (messagesToBeUpdatedCount === 0) {
        break
      }
    }
  }

  const setupStatus = chatRoom => {
    if (chatRoom.assistant) {
      setOnServiceAssistant(chatRoom.assistant.name)
    } else {
      setOnServiceAssistant("")
    }

    if (!chatRoom.assistant) {
      setSubmitDisabled(false)
    } else if (chatRoom.assistant && userInfo().id !== chatRoom.assistant.id) {
      setSubmitDisabled(true)
    } else {
      setSubmitDisabled(false)
    }
  }

  const leaveConversation = (setConversionToOpen = false) => {
    if (setConversionToOpen === true) {
      const {
        modal: {
          setCentered,
          setHeaderText,
          setModalContent,
          setOnSubmit,
          toggle
        }
      } = props

      setCentered(false)
      setHeaderText("結束服務並離開對話")
      setModalContent("確定結束服務並離開對話？")
      setOnSubmit(() =>
        leaveChatRoom().then(() => {
          setChatUser("")
          setChatRoomId("")
          setIsInitChat(true)
        })
      )
      toggle()
    } else {
      setChatUser("")
      setChatRoomId("")
      setIsInitChat(true)
    }
  }

  return (
    <div>
      <Query
        query={chatRoom}
        variables={{
          chatRoomId
        }}
        fetchPolicy="network-only"
        onCompleted={data => {
          setMessages(data?.chatRoom?.chatMessages || [])
          !isCustomer && setupStatus(data?.chatRoom)

          setIsInitChat(false)
        }}
      >
        {({ loading, data }) => {
          return (
            <div>
              <Subscription
                subscription={chatRoomMessage}
                variables={{
                  chatRoomId
                }}
                onSubscriptionData={({ subscriptionData: { data } }) => {
                  setMessages([...messages, data.chatRoomMessage])
                  !isCustomer && setupStatus(data.chatRoomMessage.chatRoom)
                }}
              >
                {() => null}
              </Subscription>
              <Card className="mb-0">
                <CardHeader>
                  <Row style={{ display: "flex", alignItems: "center" }}>
                    <Col sm={4}>
                      <i className="mdi mdi-comment-processing-outline mr-2">
                        {" "}
                      </i>
                      {!isCustomer ? chatUser : "客服人員"}
                    </Col>
                    {!isCustomer && (
                      <Col className="text-align-center center-component">
                        {loading === false &&
                          `服務人員：${onServiceAssistant || "無"}`}
                      </Col>
                    )}
                    <Col sm={4} className="text-right">
                      {!isCustomer &&
                        !isInitChat &&
                        data?.chatRoom?.assistant?.id === userInfo().id && (
                          <div>
                            <Button
                              color="link"
                              onClick={() => leaveConversation(true)}
                            >
                              <div>
                                <i className="mdi mdi-keyboard-backspace">
                                  結束服務離開對話
                                </i>
                              </div>
                            </Button>
                            <Button
                              className="mr-0"
                              outline
                              color="secondary"
                              onClick={leaveConversation}
                            >
                              <span aria-hidden="true">×</span>
                            </Button>
                          </div>
                        )}
                    </Col>
                  </Row>
                </CardHeader>
                {!isCustomer ? (
                  <MessageListBody
                    {...props}
                    messages={messages}
                    loading={loading}
                    disabled={submitDisabled}
                  />
                ) : (
                  <MessageListBody
                    chatRoomId={chatRoomId}
                    messages={messages}
                    loading={loading}
                    disabled={false}
                  />
                )}
              </Card>
            </div>
          )
        }}
      </Query>
    </div>
  )
}

const useInit = (messages, setIsInitChat) => {
  useEffect(() => {
    if (messages && messages.length > 0) {
      setIsInitChat(false)
    } else {
      setIsInitChat(true)
    }
  }, [messages, setIsInitChat])
}

MessageQueryWrapper.propTypes = {
  chatUser: PropTypes.string,
  isCustomer: PropTypes.bool,
  chatRoomId: PropTypes.string,
  modal: PropTypes.object.isRequired
}

export default compose(
  withModal,
  withRouter
)(MessageQueryWrapper)
